<div class="flex w-full">
  <!-- Selector de país -->
  <div class="relative w-auto flex-shrink-0">
    <button type="button" (click)="toggleDropdown()"
      class="h-full flex items-center gap-1 border rounded-l-md px-2 bg-gray-50 hover:bg-gray-100 text-md">
      {{ selectedCountry.flag }}
      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    <!-- Dropdown -->
    <div *ngIf="open"
      class="absolute left-0 z-10 mt-1 w-56 bg-white border rounded-md shadow-lg max-h-60 overflow-y-auto">
      <!-- buscador -->
      <input #searchInput type="text" [value]="search" (input)="onSearch($event)" class="w-full px-2 py-1 border-b text-sm rounded-r-md"
        placeholder="Search country..." />

      <div *ngFor="let c of filteredCountries" (click)="selectCountry(c)" [id]="'country-' + c.code"
        class="px-2 py-1 hover:bg-gray-100 cursor-pointer text-sm">
        {{ c.flag }} {{ c.name }} ({{ c.dial }})
      </div>
    </div>
  </div>

  <!-- Teléfono -->
  <input
    type="tel"
    [formControl]="phoneControl"
    (blur)="onInputBlur()"
    class="flex-1 min-w-0 border border-l-0 rounded-r-md px-3 py-2 focus:ring focus:ring-blue-300"
    placeholder="(201) 559-4773"
  />
</div>

<div *ngIf="showErrors" class="text-sm text-red-600 mt-1">
  <div *ngIf="errors?.['required']">{{ textService.getText('form_validate_phone') }}</div>
  <div *ngIf="errors?.['phoneFormat']">{{ textService.getText('form_validate_phone_format') }}</div>
</div>
<!-- <p>phone-number-field works!</p> -->
